import request from "asos.myaccount.request";

const COUNTRIES_ENDPOINT = "commerce/deliveryoptions/v2/countries";

export const getCountries = (lang, store, requestFn = request) =>
  requestFn(
    `${COUNTRIES_ENDPOINT}?lang=${lang}&store=${store}&expand=subRegions`
  );
